<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Mercado" />
  <menuLateral />
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <p>Bem-vindo ao Mercado!
        </p>
        <p>Pensando na sua experiência, esta aba foi criada para facilitar a adição dos nossos serviços, sem burocracias.
        Clique em "Saiba mais" para entender os nossos benefícios e siga o passo a passo para a contratação.
        </p>
        <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 d-flex align-items-stretch" v-for="(produto, indice) in listaProdutos" :key="indice">
          <Plano :plano="produto"  :key="produto.id">
            <template #subtitulo>
              <h6 class="card-subtitle text-muted">Adicional</h6>
            </template>
            <template #titulo>
              <h3 class="card-text"> {{produto.nome}}</h3>
            </template>
            <template #descricao>
              <p class="card-text text-left mt-4">{{obterDescricaoPlanoSugerido(produto)}}</p>
            </template>
            <template #valor>
              <p class="text-muted text-center small">A partir de</p>
              <h2 class="pricing-card-title text-center">
              {{ formatarValorMonetario(obterValorPlanoSugerido(produto)) }}
              </h2>
              <p class="text-muted text-center small">por {{ obterItemPlanoSugerido(produto)?.nome ?? 'mês' }}</p>
            </template>
            <template #acoes>
              <button class="botoes btn mt-4  btn-lg btn-block botao" @click="showModalContratarProduto(produto)">Saiba Mais</button>
              <p class="text-muted text-right mt-2" v-if="produto.planos.some(plano => plano.tipo === 1)">*valor mensal</p>
              <p class="text-muted text-right mt-2" v-if="produto.planos.some(plano => plano.tipo === 2)">*válido por {{ produto.planos[produto.planos.length - 1].qtd_dias_validade_credito }} dias</p>
            </template>
            <template #rodape v-if="produto.contratado">
              <div class="card-footer card-rodape" >
                  <div class="d-flex">
                      <p class="text-bold mr-auto">Contratado</p>
                      <p class="ml-auto" v-if="produto.quantidade_disponivel >= 1000000">Ilimitado {{obterItemPlanoSugerido(produto)?.nome}}</p>
                      <p class="ml-auto" v-if="produto.quantidade_disponivel < 1000000">{{ produto.quantidade_disponivel }} {{obterItemPlanoSugerido(produto)?.nome}}</p>

                  </div>
                  <div class="progress-container" >
                    <div class="progress-bar">
                      <div class="progress" :style="{ width: ((produto.quantidade_consumida / produto.quantidade_disponivel) * 100) + '%' }"></div>
                  </div>
                  <p class="progress-text mt-2" v-if="produto.quantidade_disponivel >= 1000000">Ilimitado</p>
                  <p class="progress-text mt-2" v-if="produto.quantidade_disponivel < 1000000">{{ produto.quantidade_consumida }} / {{ produto.quantidade_disponivel }} utilizados</p>
                </div>
              </div>
            </template>
          </Plano>
        </div>
      </div>

      <duvidas-frequentes></duvidas-frequentes>
    </section>
  </div>
  <!-- /.content-wrapper -->
  <DetalheAdicional v-if="abrirModal" ref="DetalheAdicional" :produto="detalhes"/>
</div>
<!-- ./wrapper -->
</template>

<script>
import Produtos from './js'
export default Produtos
</script>
<style scoped>
.text-muted {
  color: #6c757d !important;
}

.pricing-card-title {
  font-weight: bold;
}
.progress-container {
    position: relative;
}

.progress-bar {
    width: 100%;
    height: 20px;
    background-color: #f3f3f3;
    border-radius: 3px;
}

.progress {
    height: 100%;
    background: linear-gradient(to right, #194175 0%, #fc3a3a 100%);
    border-radius: 3px;
}
</style>
